import DevStageAlert from './DevStateAlert';

export default DevStageAlert;
